import React, { useContext, useState } from "react";
import { Box, FormControl, InputLabel, Input, TextField } from "@mui/material";

import styles from "./input-form.module.css";
import AppContext from "../../store/app-context";
import ButtonCircle from "../ButtonCircle/ButtonCircle";
import SnackBar from "../SnackBar/SnackBar";
import Recaptcha from "react-recaptcha";

const InputForm = ({ content }) => {
  const data = localStorage.getItem("data");
  const { name: defaultName, phone: defaultPhone } = JSON.parse(data);
  const [name, setName] = useState(defaultName);
  const [phone, setPhone] = useState(defaultPhone);
  const [inquiry, setInquiry] = useState("");
  const appCtx = useContext(AppContext);
  let label;

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const payload = {
      newName: name,
      newPhone: phone,
      extra: data.get("inquiry"),
    };
    appCtx.handleSubmit(payload);
  };

  if (appCtx.category === "complain") label = "keluhan";
  else if (appCtx.category === "ask") label = "pertanyaan";

  return (
    <>
      <ButtonCircle />
      {content.intro && <p>{content.intro}</p>}
      {!content.intro && <p></p>}
      {appCtx.hasError && <SnackBar type="error" message={appCtx.message} />}
      <Box component="form" noValidate onSubmit={handleSubmit}>
        <FormControl fullWidth variant="standard">
          <InputLabel htmlFor="name">Nama</InputLabel>
          <Input
            id="name"
            name="name"
            fullWidth
            value={name}
            onChange={handleNameChange}
          />
        </FormControl>
        <FormControl fullWidth variant="standard" sx={{ mt: 1 }}>
          <InputLabel htmlFor="phone">No. Handphone</InputLabel>
          <Input
            id="phone"
            name="phone"
            fullWidth
            value={phone}
            onChange={handlePhoneChange}
          />
        </FormControl>
        <TextField
          id="inquiry"
          name="inquiry"
          label={`Tuliskan yang menjadi ${label} Anda`}
          fullWidth
          multiline
          rows={4}
          variant="standard"
          sx={{ mt: 1 }}
          value={inquiry}
          onChange={(e) => setInquiry(e.target.value)}
        />
        <div style={{ marginTop: "20px" }}>
          <Recaptcha
            sitekey="6LdHIVsiAAAAAArfeMfuxq9g2Ta9e3YbeRQv-2lZ"
            render="explicit"
            verifyCallback={appCtx.handleVerifyCaptcha}
            onloadCallback={() => {}}
          />
        </div>
        {name && phone && inquiry && appCtx.isVerified && (
          <div className={styles.actions}>
            <button type="submit" className={styles.button}>
              Kirim
            </button>
          </div>
        )}
      </Box>
    </>
  );
};

export default InputForm;
